package com.yendo.mx.ui.home

import com.yendo.mx.models.FiltroHome
import com.yendo.mx.models.RestauranteFirebase
import com.yendo.mx.models.SeccionHome

data class HomeUiState(
    val isLoading: Boolean = true,
    val secciones: List<SeccionHome> = emptyList(),
    val filtros: List<FiltroHome> = emptyList(),
    val tienditaLocal: RestauranteFirebase? = null,
    val errorMessage: String? = null
)
